export enum roles {
    content_admin = "content-admin", // Access to admin of content (Logo & Banner)
    content_theme_admin = "content-theme-admin", // On top of content-admin to access theme
    content_deploy = "content-deploy" // Access to deploy of content
}